import { Component, HostBinding, Input } from '@angular/core';

import { BaseDirective } from '../../base/_base.directive';


@Component({
  moduleId: module.id,
  selector: 'plus-button',
  templateUrl: 'plus-button.component.html',
  styleUrls: ['plus-button.component.scss'],
})
export class PlusButtonComponent extends BaseDirective {
  @Input() expanded: boolean = false;

  // default: white square with blue plus
  // inverteted: blue square with white plus
  @HostBinding('class.inverted')
  @Input() inverted: boolean = false;

  @Input() set style(style: string) {
    this._style = style;
    this.setClassName(`style-${style}`);
  }

  @Input() set size(size: string) {
    this._size = size;
    this.setClassName(`size-${size}`);
  }

  @HostBinding('class.fat-border')
  @Input() fatBorder: boolean = false;

  @HostBinding('class.disabled')
  @Input() disabled: boolean = false;

  _style: string;
  _size: string;
}
